<template>
	<div class="content_main" style="padding: 10px;">
		<div class="content_main_top">
			<a-input v-model="asset_sn" style="margin-left: 10px;" allowClear class="a_input_self margin_self" placeholder="请输入参数名称" @keyup.enter.native="query"/>
			<a-button type="primary" @click="query"> 查询 </a-button>
		</div>
		<div class="content_main_center" id="content_main_center_scroll" style="height: calc(100% - 112px)">
			<a-table :columns="columns" :data-source="data" bordered :pagination="false" :scroll="{ y: scroll_y  }">
				<span slot="action" slot-scope="text, record">
					<a v-if="updateOperating" @click="edit(record)">编辑</a>
				</span>
			</a-table>
		</div>
		<div class="content_main_bot" style="margin-left: 10px;">
			<a-pagination v-model="current" show-size-changer :page-size.sync="pageSize" :total="total" @showSizeChange="showSizeChange"
			 :pageSizeOptions="['10', '20', '30', '50']" @change="onShowSizeChange" />
		</div>
		<a-modal title="编辑" :visible="editvisible" @ok="editOk" @cancel="editCancel" width="880px">
			<template slot="footer">
				<a-button key="back" @click="editCancel"> 取消 </a-button>
				<a-button type="primary" @click="editOk"> 保存 </a-button>
			</template>
			<a-form-model :model="detailsrow" :labelCol="labelCol" :wrapperCol="wrapperCol">
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="参数名称">
							{{ detailsrow.configName }}
						</a-form-model-item>
					</a-col>
					<a-col :span="24">
						<a-form-model-item label="参 数 值 ">
							<a-input allowClear v-model="detailsrow.configValue" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
					<a-col :span="24">
						<a-form-model-item label="参数说明">
							{{ detailsrow.remark }}
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	import {
		configlist,
		configupdate
	} from '@/api/assetmenag'
	import {
		checkPermission
	} from '@/utils/permissions'
	const columns = [{
			title: '参数名称',
			dataIndex: 'configName',
			key: 'configName',
		},
		{
			title: '参数值',
			dataIndex: 'configValue',
			key: 'configValue',
		},
		{
			title: '参数说明',
			dataIndex: 'remark',
			key: 'remark',
		},
		{
			title: '操作',
			key: 'action',
			scopedSlots: {
				customRender: 'action',
			},
		},
	]
	export default {
		data() {
			return {
				columns,
				data: [],
				asset_sn:'',
				scroll_y: 150,
				pageSize: 10,
				current: 1,
				total: 0,
				editvisible: false,
				detailsrow: {},
				labelCol: {
					span: 5,
				},
				wrapperCol: {
					span: 19,
				},
				updateOperating: checkPermission('operating:self:update'),
			}
		},
		created() {
			this.config_list()
		},
		mounted() {
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				console.log(max_h, 'sssssssss')
				setTimeout(() => {
					console.log($('.ant-table-header').height(), 'aaaaaaaaaaaaa')
					this.scroll_y = max_h - $('.ant-table-header').height()
					console.log(this.scroll_y)
				}, 1000)
			})
		},
		methods: {
			query(){
				this.config_list()
			},
			edit(row) {
				this.editvisible = true
				this.detailsrow = row
			},
			config_list() {
				configlist({
					pageSize: this.pageSize,
					pageNum: this.current,
					configType: 'N',
					configName:this.asset_sn,
				}).then((res) => {
					this.total = res.total
					this.data = res.rows
				})
			},
			showSizeChange(current, pageSize) {
				this.pageSize = pageSize
				this.current = current
				this.config_list()
			},
			onShowSizeChange(current, pageSize) {
				this.selectedRowKeys = []
				this.selectedRow = []
				this.current = current
				this.config_list()
			},
			editCancel() {
				this.editvisible = false
			},
			editOk() {
				configupdate(this.detailsrow).then((res) => {
					this.editvisible = false
					this.$message.success('编辑成功')
					this.config_list()
					console.log(res)
				})
			},
		},
	}
</script>

<style>
</style>
